module.exports = __webpack_public_path__ + "static/perftweak-a61319249c250f508621ea8f4acaef60.png";